import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-benefits-modal',
  templateUrl: './benefits-modal.component.html',
  styleUrls: ['./benefits-modal.component.scss'],
})
export class BenefitsModalComponent implements OnInit {
  constructor(private modalController: ModalController) {}

  ngOnInit() {}
  closeModal() {
    this.modalController.dismiss();
  }
}
